import { computed } from 'vue';
import store from '@/store/index'
import StatusComponenteConstant from '@/constants/StatusComponenteConstant';

class ComponentesService {
    _getCompoenetes(modulo) {
        const modulos = computed(() => store.state.modulos)
        return modulos.value.find(module => module.idChecklistModulo == modulo).etapas.componentes
    }

    validaStatusRespostaComponente(respostaObrigatoria, respondido) {
        let status = StatusComponenteConstant.NAO_PREENCHIDO.chave
        if (respostaObrigatoria && !respondido) {
            status = StatusComponenteConstant.PENDENTE.chave
        } else if (respondido) {
            status = StatusComponenteConstant.PREENCHIDO.chave
        }
        return status;
    }

    salvarStatusComponente(etapa, idComponente, modulo, status) {
        if (status != '') {
            const componentes = this._getCompoenetes(modulo)
            if (typeof componentes[etapa][idComponente] != 'undefined') {
                componentes[etapa][idComponente].status = status
            }
        }
    }

    salvarRespostaEstadoComponente(modulo, etapa, idComponente, resposta, idComponentePai = '') {
        const componentes = this._getCompoenetes(modulo)
        if (idComponentePai == '') {
            componentes[etapa][idComponente].respostas = resposta
            componentes[etapa][idComponente].respostaAlterada = true
        } else {
            componentes[etapa][idComponentePai].opcoes[idComponente].respostas = resposta
            componentes[etapa][idComponentePai].opcoes[idComponente].respostaAlterada = true
            componentes[etapa][idComponentePai].respostaAlterada = true
        }
    }
}

export default new ComponentesService()